<app-topnav></app-topnav>
<app-video-tile></app-video-tile>
<!--
<section id="hero" class="d-flex align-items-center">

  <div class="container">
    <div class="row align-items-center">
      <div class="col-12">
        <div class="row justify-content-center">
          <div class="col-md-7 text-center hero-text">
            <h1 data-aos="fade-up" data-aos-delay="">Sign Up</h1>
            <p class="mb-5" data-aos="fade-up" style="color: white;" data-aos-delay="100">Get a attractive digital visiting card from us by signup</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</section> -->

<main id="main">
<section class="section">
  <div class="container">
 <h1 data-aos="fade-up" data-aos-delay="">Sign Up</h1>
            <p class="mb-5" data-aos="fade-up" style="color: white;" data-aos-delay="100">Get a attractive digital visiting card from us by signup</p>

    <div class="col-md-12 mb-5 mb-md-0" data-aos="fade-up">
       <form (ngSubmit)="signup(signUpForm.value)" [formGroup]="signUpForm" role="form">

        <div class="row">
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Name<span style="color: red;">*</span></label> -->
            <input type="text" placeholder="Name*" name="name" class="form-control" formControlName="name" id="name"  required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Email<span style="color: red;">*</span></label> -->
            <input type="email" placeholder="Email*" #email class="form-control" formControlName="email" name="email" id="email" required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Phone No<span style="color: red;">*</span></label> -->
            <input type="text" placeholder="Phone No*" name="phoneno" class="form-control" formControlName="phoneno" id="phoneno"  required>
          </div>
          <!-- <div class="col-md-12 form-group mt-3"> -->
            <!-- <label for="name">Alternative No</label> -->
            <!-- <input type="text" placeholder="Alternative No" class="form-control" name="altno"  id="altno" required> -->
          <!-- </div> -->
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Aadhar No<span style="color: red;">*</span></label> -->
            <input type="text" placeholder="Password*" name="password" class="form-control" formControlName="password"  id="password"  required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Aadhar No<span style="color: red;">*</span></label> -->
            <!-- <input type="text" placeholder="Confirm Password*" name="cpassword" class="form-control"  id="cpassword"  required> -->
          </div>



          <div class="col-md-12 mb-3">
            <!-- <div class="sent-message" style="color: red;">{{error}}</div>
            <div class="sent-message" style="color: green;">{{success}}</div> -->
          </div>
          <div class="col-md-6 form-group">&nbsp;
          </div>
          <div class="col-md-6 form-group">
            <input type="submit" [disabled]="!signUpForm.valid" class="btn btn-primary d-block w-100" value="Sign Up">
          </div>
        </div>

      </form>
    </div>


  </div>
</section>


</main>
